module.exports = __webpack_public_path__ + "media/en_us_s4_Pamela.ff3d0594.mp3";